import dynamic from 'next/dynamic';

export const ContactCTA = dynamic(() => import('./ContactCTA'));
export const Popup = dynamic(() => import('./Popup'));
export const Breadcrumb = dynamic(() => import('./Breadcrumb'));
export const PopupCircle = dynamic(() => import('./PopupCircle'));
export const Testimonials = dynamic(() => import('./Testimonials'));
export const VisionMissionValues = dynamic(() => import('./VisionMissionValues'));
export const AllCertificates = dynamic(() => import('./AllCertificates'));
export { default as SEOHead } from './SEOHead';
